module.exports = __webpack_public_path__ + "img/an5.b7afe493.png";